import { Shield, Twitter, Linkedin, Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react"
import { FadeIn } from "./ui/fade-in"
import { Link } from "react-router-dom"
import { TextHoverEffect } from "./ui/text-hover-effect"

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
      <footer className="text-white pt-16 pb-8 relative overflow-hidden">
        {/* Background animated text */}
        <div className="h-[20rem] flex items-center justify-center font-orbitron">
          <TextHoverEffect text="Secure&More" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <FadeIn direction="up">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
              <div>
                <div className="flex items-center mb-2">
                  <Shield className="w-8 h-8 text-red-600" />
                  <span className="font-bold text-xl">S&M</span>
                </div>

                <p className="text-gray-400 mb-4">
                  Solutions de cybersécurité avancées pour les entreprises de toutes tailles. Protection de vos actifs
                  numériques 24/7.
                </p>
                <div className="flex gap-4">
                  <a href="#" className="text-gray-400 hover:text-red-600 transition-colors">
                    <Twitter className="w-5 h-5" />
                  </a>
                  <a href="#" className="text-gray-400 hover:text-red-600 transition-colors">
                    <Linkedin className="w-5 h-5" />
                  </a>
                  <a href="#" className="text-gray-400 hover:text-red-600 transition-colors">
                    <Facebook className="w-5 h-5" />
                  </a>
                  <a href="#" className="text-gray-400 hover:text-red-600 transition-colors">
                    <Instagram className="w-5 h-5" />
                  </a>
                </div>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-4">Entreprise</h3>
                <ul className="space-y-2">
                  <li>
                    <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                      À propos de nous
                    </Link>
                  </li>
                  <li>
                    <a href="#" className="text-gray-400 hover:text-white transition-colors">
                      Carrières
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-gray-400 hover:text-white transition-colors">
                      Blog
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-gray-400 hover:text-white transition-colors">
                      Presse
                    </a>
                  </li>
                  <li>
                    <Link to="/partners" className="text-gray-400 hover:text-white transition-colors">
                      Partenaires
                    </Link>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-4">Ressources</h3>
                <ul className="space-y-2">
                  <li>
                    <a href="#" className="text-gray-400 hover:text-white transition-colors">
                      Documentation
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-gray-400 hover:text-white transition-colors">
                      Guide de sécurité
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-gray-400 hover:text-white transition-colors">
                      Webinaires
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-gray-400 hover:text-white transition-colors">
                      Études de cas
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-gray-400 hover:text-white transition-colors">
                      FAQ
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-4">Contact</h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <Mail className="w-5 h-5 text-red-600 mt-0.5" />
                    <span className="text-gray-400">contact@sm-security.com</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Phone className="w-5 h-5 text-red-600 mt-0.5" />
                    <span className="text-gray-400">+33 (0)1 23 45 67 89</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MapPin className="w-5 h-5 text-red-600 mt-0.5" />
                    <span className="text-gray-400">
                    123 Avenue de la Cybersécurité
                    <br />
                    75008 Paris, France
                  </span>
                  </li>
                </ul>
              </div>
            </div>
          </FadeIn>

          <div className="pt-8 border-t border-white/10 text-center text-gray-500 text-sm">
            <p>&copy; {currentYear} S&M. Tous droits réservés.</p>
            <div className="flex justify-center gap-6 mt-4">
              <Link to="/legal/privacy-policy" className="hover:text-white transition-colors">
                Politique de confidentialité
              </Link>
              <Link to="/legal/terms-of-use" className="hover:text-white transition-colors">
                Conditions d'utilisation
              </Link>
              <Link to="/legal/legal-notice" className="hover:text-white transition-colors">
                Mentions légales
              </Link>
            </div>
          </div>
        </div>
      </footer>
  )
}
